export default "__VITE_ASSET__DxwGTaYT__"